import React, { Component } from 'react'
import './index.css'
import  PricingFeatures  from '../../../Basic/TrustBlocks/PricingFeatures';
import  ForgeFeatures  from '../../../Basic/TrustBlocks/ForgeFeatures';




export default class About extends Component {
  constructor (props) {
    super(props);
      this.state = {
        lang: ''
      }

  }


    render () {

    return (

      <div className="container__about-content">
                <div className="advantages">
                    <ForgeFeatures/>
                    <PricingFeatures/>
      </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DynamicContent/Main/About__block/index.js